import { render } from "./BlankImage.vue?vue&type=template&id=2081a25e&scoped=true&ts=true"
import script from "./BlankImage.vue?vue&type=script&lang=ts"
export * from "./BlankImage.vue?vue&type=script&lang=ts"

import "./BlankImage.vue?vue&type=style&index=0&id=2081a25e&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2081a25e"]])

export default __exports__